<template>
  <div ref="root" ref:class="dh-psy-esi" :data-esi-src='src' v-if="innerHTML" v-html="innerHTML"></div>
  <div ref="root" ref:class="dh-psy-esi" :data-esi-src='src' v-else v-html="esiStr"></div>
</template>

<script>
export default {
  props: {
    src: { type: String },
    beforeHTML: { type: String, default: '' },
    afterHTML: { type: String, default: '' }
  },
  data() {
    return {
      innerHTML: ''
    }
  },
  created() {
    if (typeof window !== 'undefined') {
      const rootEl = document.querySelector(`[data-esi-src="${this.src}"]`)
      this.innerHTML = rootEl && rootEl.innerHTML
    } else {
      this.innerHTML = `${this.beforeHTML}<esi:include src="${this.src}"></esi:include>${
        this.afterHTML
      }`
    }
  },
  computed: {
    esiStr() {
      return `<esi:include src="${this.src}"></esi:include>`
    }
  }
}
</script>
